<template>
  <div class="sports-page">
    <v-layout  class="page-layout">
      <v-flex class="main-column" :style="{paddingTop: headerHeight + 'px'}" ref="maincolumn">
        <resize-observer @notify="mainColumnResize" />
        <v-layout class="page-layout">
          <v-flex class="left-column">
            <sports-menu v-if="tabletAndAbove"></sports-menu>
          </v-flex>
          <v-flex class="center-column">
            <router-view></router-view>
          </v-flex>
          <!-- <v-flex class="betslip-column" v-if="tabletAndAbove">
            <div class="toggleBetslip" :class="{'loggedIn' : isLoggedIn}">
            <div class="betslipTabs" :class="[{'noHistory': !showHistoryTabs},{'loggedIn': isLoggedIn}]">
              <span class="tab" :class="{ 'active': activeBetSlipHistoryTab!=='active' && activeBetSlipHistoryTab!=='settled', disabled: true }">
                <a @click="setTab('BetSlip')" class="betsliptablink a-link-">
                  <span>{{ $t('BetSlipPage.tab.BetSlip') }}</span>
                  <badge v-if="betsNo > 0">{{betsNo}}</badge>
                </a>
              </span>
              <template v-if="showHistoryTabs === true">
                <span v-if="isLoggedIn" class="tab" :class="{ 'active': activeBetSlipHistoryTab==='active' }">
                  <a @click="setTab('HistoryActive')" class="a-link-"><span>{{ $t('BetSlipPage.tab.History.active') }}</span></a>
                </span>
                <span v-if="isLoggedIn" class="tab" :class="{ 'active': activeBetSlipHistoryTab==='settled' }">
                  <a @click="setTab('HistorySettled')" class="a-link-"><span>{{ $t('}BetSlipPage.tab.History.settled') }}</span></a>
                </span>
              </template>
            </div>
            <v-btn :ripple="false" @click="toggleBetslip">
              <span :class="betslipVisible ? 'pd-icon pd-icon-chevron-down' : 'pd-icon pd-icon-chevron-top'"></span>
            </v-btn>
          </div>
            <vue-slide-up-down :active="betslipVisible" :duration="500" ref="upDownBetslip">
              <betslip></betslip>
            </vue-slide-up-down>
            <div class="banners">
              <headlinesLight category="SidebarBanners" ></headlinesLight>
            </div>
          </v-flex> -->
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import Screen from '@/components/mixins/Screen'
  import store from '@/store'

  import VueSlideUpDown from 'vue-slide-up-down'

  import SportsMenu from '@/components/sports/bettingoffer/SportsMenu'
  import Headlines from '@/components/sports/bettingoffer/headlines'
  import SportsMenuMobile from '@/components/sports/bettingoffer/SportsMenuMobile'
  import Betslip from '@/components/sports/betslip/BetslipPage'
  import HeaderPart from '@/components/layout/parts/HeaderPart'
  import Badge from '@/components/common/Badge'
  import headlinesLight from '@/components/sports/bettingoffer/headlinesLight'

  export default {
    name: 'SportsLayout',

    mixins: [
      Screen
    ],

    components: {
      SportsMenu,
      Headlines,
      SportsMenuMobile,
      Betslip,
      VueSlideUpDown,
      HeaderPart,
      Badge,
      headlinesLight
    },

    props: {

    },

    data: () => ({
      betslipVisible: true
    }),

    computed: {
      isOpenedFromWebView () {
        return store.getters['getIsOpenedFromWebView']
      },
      headerMessageState () {
        return store.getters['overlayState/getHeaderMessageState']
      },
      headerHeight () {
        return store.getters['screenState/getHeaderHeight']
      },
      headerMessageHeight () {
        return store.getters['screenState/getHeaderMessageHeight']
      },
      mainColumnWidth () {
        return store.getters['screenState/getMainColumnWidth']
      },
      betsNo () {
        return store.getters['sbBetslipState/selectionsNo']
      },
      isLoggedIn () {
        return store.getters['isLoggedIn']
      },
      activeBetSlipHistoryTab () {
        return store.getters['sbBetslipState/activeBetSlipHistoryTab']
      },
      showHistoryTabs () {
        return window.ctsautoconf.SHOW_BETHISTORY_IN_BETSLIP
      }
    },
    mounted () {
      this.mainColumnResize()
    },

    methods: {
      mainColumnResize () {
        var mainColumn = this.$refs.maincolumn

        if (mainColumn) {
          store.commit('screenState/setMainColumnWidth', mainColumn.offsetWidth)
        }
      },
      toggleBetslip () {
        if (!this.betslipVisible) {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }, 200)
        }
        this.betslipVisible = !this.betslipVisible
      },
      toggleBetslipActiveTab () {
        if (!this.betslipVisible) {
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' })
          }, 200)
          this.betslipVisible = !this.betslipVisible
        }
      },
      setTab (tab, noscroll) {
        let initObj = { }
        if (!this.isLoggedIn) tab = 'BetSlip'

        // trigger autoload on Statement tabs only
        switch (tab) {
          case 'HistoryActive':
            initObj.fetchHistory = true
            initObj.queryStatus = 'Open'
            initObj.historyDateRange = { from: null, to: null }
            store.commit('sbBetslipState/setActiveBetSlipHistoryTab', 'active')
            this.toggleBetslipActiveTab()
            break
          case 'HistorySettled':
            initObj.fetchHistory = true
            initObj.queryStatus = 'NonOpen'
            initObj.historyDateRange = { from: new Date(), to: new Date() }
            initObj.historyDateRange.from.setDate(initObj.historyDateRange.from.getDate() - 7) // move from 7 days in the past
            store.commit('sbBetslipState/setActiveBetSlipHistoryTab', 'settled')
            this.toggleBetslipActiveTab()
            break
          default:
            store.commit('sbBetslipState/setActiveBetSlipHistoryTab', '')
            this.toggleBetslipActiveTab()
            break
        }
        store.dispatch('statementState/initStatement', initObj)
        if (!noscroll) {
          setTimeout(() => {
            window.scrollTo({top: 0, behavior: 'smooth'})
          }, 200)
        }
      }
    },

    watch: {
      betsNo (newVal, oldVal) {
        if (this.activeBetSlipHistoryTab === 'active' || this.activeBetSlipHistoryTab === 'settled') {
          this.setTab('BetSlip', newVal < oldVal)
        }
      }
    },

    created () {

    }
  }
</script>

<style lang="stylus" scoped>
  @import "~@/css/config"

  .url-state-name-sports-live
    .content
      .page-layout
        .background-headline
          height: 180px
          @media mobile-big-and-below
            height: 165px
          >>>.background-image
            @media mobile-big-and-below
              height 175px

</style>



// WEBPACK FOOTER //
// src/components/layout/SportsLayout.vue